<template>
  <div class="records-page">
    <div class="header-section">
      <div class="header-bg"></div>
      <van-nav-bar
        title="答题记录"
        left-arrow
        @click-left="goBack"
        :border="false"
        class="nav-bar"
      />
      <div class="header-content">
        <div class="stats-card">
          <div class="stats-grid">
            <div class="stat-block">
              <div class="stat-icon-wrap">
                <van-icon name="clock-o" size="24" color="#fff" />
              </div>
              <span class="stat-num">{{ totalRecords }}</span>
              <span class="stat-label">总记录</span>
            </div>
            <div class="stat-divider" />
            <div class="stat-block">
              <div class="stat-icon-wrap success">
                <van-icon name="thumb-circle-o" size="24" color="#fff" />
              </div>
              <span class="stat-num">{{ completedRecords }}</span>
              <span class="stat-label">已完成</span>
            </div>
            <div class="stat-divider" />
            <div class="stat-block">
              <div class="stat-icon-wrap warning">
                <van-icon name="clock-o" size="24" color="#fff" />
              </div>
              <span class="stat-num">{{ pendingRecords }}</span>
              <span class="stat-label">待评分</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="filter-header">
        <van-dropdown-menu class="filter-menu">
          <van-dropdown-item
            v-model="filterSubCategoryId"
            :options="subCategoryOptions"
            @change="onFilterChange"
            class="filter-item"
          />
        </van-dropdown-menu>
        <!-- <div class="filter-hint">
          <van-icon name="filter" size="14" color="#999" />
          <span>筛选分类</span>
        </div> -->
      </div>

      <div class="record-list">
        <div class="list-header">
          <span class="list-title">答题记录</span>
          <span class="list-count">共 {{ totalRecords }} 条</span>
        </div>
        
        <div
          v-for="(record, index) in records"
          :key="record.id"
          class="record-card"
          :style="{ animationDelay: index * 0.08 + 's' }"
          @click="viewDetail(record.id)"
        >
          <div class="card-accent" :style="{ background: getCategoryColor(record) }" />

          <div class="card-content">
            <div class="card-header">
              <div class="category-tag" :style="{ background: getCategoryColor(record) }">
                <van-icon :name="getCategoryIcon(record)" size="18" color="#fff" />
              </div>
              <div class="category-info">
                <div class="category-name">{{ record.category_name }}</div>
                <div class="sub-category">{{ record.sub_category_name }}</div>
              </div>
              <span class="record-time">{{ formatDate(record.answer_time) }}</span>
            </div>

            <div class="card-body">
              <div class="info-grid">
                <div class="info-item">
                  <div class="info-icon">
                    <van-icon name="clock-o" size="16" />
                  </div>
                  <div class="info-content">
                    <span class="info-label">用时</span>
                    <span class="info-value">{{ formatTime(record.total_time) }}</span>
                  </div>
                </div>
                <div class="info-item">
                  <div class="info-icon">
                    <van-icon name="edit" size="16" />
                  </div>
                  <div class="info-content">
                    <span class="info-label">答题</span>
                    <span class="info-value">{{ record.question_count }}题</span>
                  </div>
                </div>
                <div class="info-item" v-if="record.pending_score_count === 0">
                  <div class="info-icon trophy">
                    <van-icon name="trophy" size="16" />
                  </div>
                  <div class="info-content">
                    <span class="info-label">得分</span>
                    <span class="info-value score">{{ record.total_score }}分</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <div class="footer-left">
                <div class="recording-badge" v-if="record.has_recording">
                  <van-icon name="mic-o" size="14" />
                  <span>{{ record.recording_score ? record.recording_score + '分' : '评分中' }}</span>
                </div>
              </div>
              <div class="footer-right">
                <div 
                  class="status-tag" 
                  :class="record.pending_score_count > 0 ? 'status-pending' : 'status-completed'"
                >
                  <van-icon :name="record.pending_score_count > 0 ? 'clock-o' : 'passed'" size="14" />
                  <span>{{ record.pending_score_count > 0 ? '待评分' : '已完成' }}</span>
                </div>
                <van-icon name="arrow-right" size="18" class="arrow-icon" />
              </div>
            </div>
          </div>
        </div>

        <div v-if="records.length === 0 && !loading" class="empty-wrapper">
          <div class="empty-illustration">
            <van-icon name="file-text-o" class="empty-icon" />
          </div>
          <h3 class="empty-title">暂无答题记录</h3>
          <p class="empty-desc">快去完成答题，记录你的学习成果吧</p>
          <van-button 
            type="primary" 
            round 
            size="large" 
            class="empty-btn"
            @click="$router.push('/quiz')"
          >
            开始答题
          </van-button>
        </div>
        
        <div v-if="loading" class="loading-wrapper">
          <van-loading size="32px" vertical>
            <span class="loading-text">加载中...</span>
          </van-loading>
        </div>
      </div>

      <div class="pagination-wrap" v-if="totalPages > 1">
        <van-pagination
          v-model="page"
          :page-count="totalPages"
          :show-page-size="5"
          force-ellipses
          @change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'Records',
  data() {
    return {
      records: [],
      page: 1,
      pageSize: 20,
      loading: false,
      filterSubCategoryId: 0,
      subCategoryOptions: [{ text: '全部分类', value: 0 }],
      total: 0,
      totalPages: 1
    }
  },
  computed: {
    totalRecords() { return this.total || this.records.length },
    completedRecords() { return this.records.filter(r => r.pending_score_count === 0).length },
    pendingRecords() { return this.records.filter(r => r.pending_score_count > 0).length }
  },
  mounted() {
    this.loadSubCategories()
    this.loadRecords()
  },
  methods: {
    goBack() { this.$router.push('/home') },
    async loadSubCategories() {
      try {
        const { data } = await this.$http.get('/api/categories')
        const categories = data.data?.categories || []
        categories.forEach(cat => {
          cat.sub_categories?.forEach(sub => {
            this.subCategoryOptions.push({
              text: `${cat.name} - ${sub.name}`,
              value: sub.id
            })
          })
        })
      } catch (err) {}
    },
    normalizeRecordsPayload(body) {
      if (body == null) return { list: [], pagination: null }
      if (Array.isArray(body)) return { list: body, pagination: null }
      const list =
        body.records ||
        body.list ||
        body.items ||
        (Array.isArray(body.data) ? body.data : null) ||
        []
      return { list: Array.isArray(list) ? list : [], pagination: body.pagination || null }
    },
    async loadRecords() {
      try {
        this.loading = true
        const params = { page: this.page, page_size: this.pageSize }
        if (this.filterSubCategoryId > 0) params.sub_category_id = this.filterSubCategoryId
        const res = await this.$http.get('/api/answer/records', { params })
        const body = res.data && res.data.data !== undefined ? res.data.data : res.data
        const { list, pagination } = this.normalizeRecordsPayload(body)
        this.records = list.filter(r => r && r.id != null)
        if (pagination) {
          this.total = parseInt(pagination.total, 10) || 0
          this.totalPages =
            parseInt(pagination.total_pages ?? pagination.totalPages, 10) ||
            Math.max(1, Math.ceil(this.total / this.pageSize))
        } else {
          this.total = this.records.length
          this.totalPages = 1
        }
      } catch (err) {
        console.error('loadRecords', err)
        Toast.fail(err.message || '加载失败')
        this.records = []
      } finally {
        this.loading = false
      }
    },
    onPageChange(page) {
      this.page = page
      this.loadRecords()
    },
    onFilterChange(v) { this.filterSubCategoryId = v; this.page = 1; this.loadRecords() },
    viewDetail(id) { this.$router.push(`/record/${id}`) },
    formatDate(timestamp) {
      if (!timestamp) return '未知时间'
      const d = new Date(timestamp * 1000)
      const now = Date.now()
      const diff = now - d.getTime()
      if (diff < 60000) return '刚刚'
      if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`
      if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`
      return `${d.getMonth() + 1}月${d.getDate()}日`
    },
    formatTime(s) {
      if (!s) return '0秒'
      const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60
      return h ? `${h}小时${m}分` : m ? `${m}分${sec}秒` : `${sec}秒`
    },
    getCategoryColor(record) {
      const list = ['#6366f1', '#f97316', '#0ea5e9', '#22c55e', '#ec4899']
      return list[(record.category_id || 0) % list.length]
    },
    getCategoryIcon(record) {
      const icons = ['music-o', 'video-o', 'book-o', 'star-o', 'trophy']
      return icons[(record.category_id || 0) % icons.length]
    }
  }
}
</script>

<style scoped>
::v-deep .van-nav-bar__title{
  color: #fff;
}
::v-deep .van-nav-bar .van-icon{
  color: #fff;
}
.records-page {
  min-height: 100vh;
  background: #f5f6fa;
}

.header-section {
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding-bottom: 24px;
  border-radius: 0 0 32px 32px;
  overflow: hidden;
}

.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
  backdrop-filter: blur(10px);
}

.nav-bar {
  position: relative;
  z-index: 1;
  background: transparent;
  
}

.nav-bar .van-nav-bar__title {
  color: white;
  font-weight: 600;
  font-size: 18px;
}

.nav-bar .van-nav-bar__left,
.nav-bar .van-nav-bar__right {
  color: white;
}

.nav-bar .van-nav-bar__left .van-icon {
  color: white !important;
}

.header-content {
  position: relative;
  z-index: 1;
  padding: 0 20px;
}

.stats-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  margin-top: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.stats-grid {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.stat-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stat-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon-wrap.success {
  background: rgba(34, 197, 94, 0.3);
}

.stat-icon-wrap.warning {
  background: rgba(249, 115, 22, 0.3);
}

.stat-num {
  font-size: 28px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

.stat-divider {
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.3);
}

.content {
  padding: 20px 16px 100px 16px;
  margin-top: -20px;
}

.filter-header {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border-radius: 16px;
  padding: 12px 16px;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

.filter-menu {
  flex: 1;
  background: transparent;
}

.filter-item .van-dropdown-item__content {
  font-size: 14px;
  color: #1a1a2e;
  font-weight: 500;
}

.filter-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #999;
  padding: 6px 10px;
  background: #f5f6fa;
  border-radius: 20px;
}

.record-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px;
}

.list-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
}

.list-count {
  font-size: 13px;
  color: #999;
}

.record-card {
  position: relative;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  animation: slideUp 0.4s ease-out forwards;
  opacity: 0;
  transform: translateY(20px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.record-card:active {
  transform: scale(0.98);
}

.card-accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}

.card-content {
  padding: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.category-tag {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.category-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.category-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
}

.sub-category {
  font-size: 13px;
  color: #999;
}

.record-time {
  font-size: 12px;
  color: #999;
  padding: 4px 10px;
  background: #f5f6fa;
  border-radius: 12px;
}

.card-body {
  margin-bottom: 16px;
}

.info-grid {
  display: flex;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f5f6fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
}

.info-icon.trophy {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  color: #f59e0b;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.info-label {
  font-size: 12px;
  color: #999;
}

.info-value {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}

.info-value.score {
  color: #f59e0b;
  font-size: 16px;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 14px;
  border-top: 1px solid #f0f0f0;
}

.footer-left {
  flex: 1;
}

.footer-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.recording-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #0ea5e9;
  padding: 4px 10px;
  background: #f0f9ff;
  border-radius: 20px;
  font-weight: 500;
}

.status-tag {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.status-pending {
  background: linear-gradient(135deg, #fff7ed, #ffedd5);
  color: #ea580c;
}

.status-completed {
  background: linear-gradient(135deg, #f0fdf4, #dcfce7);
  color: #16a34a;
}

.arrow-icon {
  color: #cbd5e1;
  transition: transform 0.3s ease;
}

.record-card:active .arrow-icon {
  transform: translateX(4px);
}

.empty-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: 40px 20px;
  text-align: center;
}

.empty-illustration {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea20, #764ba220);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.15);
}

.empty-icon {
  font-size: 56px;
  color: #667eea;
  opacity: 0.6;
}

.empty-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 8px;
}

.empty-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 32px;
}

.empty-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
  font-weight: 600;
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
}

.loading-text {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}

.pagination-wrap {
  margin-top: 24px;
  padding: 16px 0;
  text-align: center;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 375px) {
  .info-grid {
    gap: 12px;
  }
  
  .info-icon {
    width: 32px;
    height: 32px;
  }
  
  .info-value {
    font-size: 13px;
  }
  
  .info-value.score {
    font-size: 14px;
  }
}
</style>